import React from 'react';
import { Container } from '@/components/ui/container';

const HeroImage = () => {
  return (
    <section className="py-8 md:py-12 bg-background">
      <Container>
        <div className="w-full">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4573c921a180bd9c4850dcd66399368b84d6ecb2d33f5411514a1c1327c9b5bd?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
            alt="AI Recruitment Platform"
            className="w-full h-auto object-contain rounded-lg"
            loading="lazy"
          />
        </div>
      </Container>
    </section>
  );
};

export default HeroImage;